import { getItem } from 'hb-react/shared/utils/sessionStorage';

export const SESSION_STORAGE_KEY = 'hivebrite-quill-editor-colors';

const getColorPresets = () => getItem({ key: SESSION_STORAGE_KEY });

export default getColorPresets;
